import { render, staticRenderFns } from "./Tokens.vue?vue&type=template&id=5e96873e"
import script from "./Tokens.vue?vue&type=script&lang=js"
export * from "./Tokens.vue?vue&type=script&lang=js"
import style0 from "./Tokens.vue?vue&type=style&index=0&id=5e96873e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports